import ServiceCategoryCard from "../../components/services/ServiceCategoryCard";
import { Link } from "react-router-dom";
import useAppData from "../../hooks/useAppData";
import SectionHeading from "../../components/common/SectionHeading"; // Assuming this is where you put it

const Services = () => {
	const { categories, servicePage } = useAppData();

	return (
		<>
			<title>{servicePage.meta_title}</title>
			<meta name="description" content={servicePage.meta_description} />
			<meta name="keywords" content={servicePage.meta_keywords} />

			<main className="bg-white min-h-screen">
				{/* Modern Split Banner */}
				<section className="relative flex flex-col md:flex-row h-auto md:h-112.5 overflow-hidden">
					{/* Image Side */}
					<div className="w-full md:w-1/2 bg-gray-100 flex justify-center items-center p-8">
						<img
							src="/assets/images/cardboard-boxes.png"
							className="max-h-full object-contain animate-float" // You can add a subtle float animation in CSS
							alt="Logistics Services"
						/>
					</div>

					{/* Text Side */}
					<div className="w-full md:w-1/2 bg-brand-600 flex flex-col justify-center px-8 md:px-16 py-12 text-white">
						<div className="max-w-md">
							<h1 className="Ethnocentric text-2xl md:text-4xl leading-tight uppercase mb-4">
								Built for <span className="text-brand-300">speed</span>, <br />
								backed by <span className="text-brand-300">trust</span>
							</h1>
							<p className="text-lg opacity-90 border-l-4 border-brand-300 pl-4">
								Experience logistics delivered. Our priority is your delivery,
								optimized for the modern world.
							</p>
						</div>
					</div>
				</section>

				{/* Services Grid Section */}
				<section className="max-w-7xl mx-auto px-4 md:py-20 py-15">
					<div className="flex flex-col items-center mb-16">
						<SectionHeading
							subtitle="Our Expertise"
							title="Logistic Services"
							alignment="center"
						/>
					</div>

					<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-8">
						{categories.map((category, index) => (
							<Link
								key={index}
								to={`/services/${category.slug}`}
								className="group h-full no-underline transition-transform duration-300 ha:-translate-y-2"
							>
								<ServiceCategoryCard
									image={category.icon_url}
									title={category.title}
									short_description={category.short_description}
								/>
							</Link>
						))}
					</div>
				</section>
			</main>
		</>
	);
};

export default Services;
